

<!-- ESF autorizadas -->
<div class="autorithedESFs ESFAutorizadas_element_to_target " *ngIf="myInvoicingServices.length > 0">
  <div class="card infoEmpresa">
    <div class="card-header">
			<span translate>
                inv.createIS.autorizatedESFTitle
            </span>
    </div>
    <div class="card-body">
      <p translate>inv.createIS.autorizatedESFTxt</p>
      <table class="table table-hover table-striped">
        <thead>
        <tr>
          <th class="d-none d-sm-table-cell" scope="col">
            <span class="" translate="">NIF</span>
          </th>
          <th class="d-lg-table-cell" scope="col"><span translate="">inv.createIS.ESFNombre</span></th>
          <th class="acciones" scope="col"><span class="d-none d-md-block" translate="">inv.createIS.ESFPredet</span><span class="d-block d-md-none" translate="">inv.createIS.ESFPredetMin</span></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let invoicingService of myInvoicingServices ">
          <td class="d-none d-sm-table-cell"><a [routerLink]="['/empresas/'+invoicingService.identifier+'/plataformas']">{{ invoicingService.identifier }}</a></td>
          <td>{{ invoicingService.tradeName }}</td>
          <td class="acciones">
            <label class="form-check-label pseudocheck">
              <input class="form-check-input ng-untouched ng-pristine ng-valid" [checked]="markAsChecked(invoicingService)" (click)="setPreference(invoicingService)" type="radio" name="autorithedESFs">
              <span></span>
            </label>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!--FIN ESF autorizadas -->

<!-- Noropia ESF -->
<div class="bloqueNotFound noESF_element_to_target" *ngIf="!myInvoicingService.identifier">
  <p class="card-text" [innerHTML]="'inv.createIS.noESF' | translate:{ nif: person.identifier}"></p>
  <a class="btn btn-primary" [routerLink]="['/empresas/nueva-empresa-servicio-facturacion']"><i class="fa fa-pencil"></i><span class="d-none d-md-inline-block" translate>inv.createIS.noESFBtFull</span><span class="d-inline-block d-md-none" translate>inv.createIS.noESFBt</span></a>
</div>
<!--FIN  Noropia ESF -->


// WEBPACK FOOTER //
// ./src/app/app-manager/invoicing-services/inv-invoicing-service-list/inv-invoicing-service-list.component.html